<template>
    <b-card-group>
        <b-card no-body>
            <div class="card-body">
                <div>
                    <div class="filter-form">
                        <b-row>
                            <b-col cols="1">
                              <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                                <font-awesome-icon icon="times" />
                                {{ $t('Сброс') }}
                              </b-button>
                            </b-col>
                            <filter-input cols="2" :label="$t('Значение')" v-model="form.translation" v-on:onBlur="search"></filter-input>
                        </b-row>
                    </div>
                </div>
            </div>
        </b-card>
    </b-card-group>
</template>

<script>
  import BaseFilter from "@/models/base.filter";

  export default {
    name: "filter-form",
    extends: BaseFilter,
    props: {
      translation: String
    },
    data() {
      return {
        form: {
          translation: this.translation
        }
      };
    }
  };
</script>
